import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Navbar.css';

function Navbar() {
  const location = useLocation();
  const { user } = useAuth();
  
  if (!user) return null;

  const getNavLinkTo = (path) => {
    if (path === '/watchlist') {
      path = `/profile/${user.uid}`;
    }

    const hasSearch = Boolean(location.search) || Boolean(location.state?.activeSearch);
    const isOnSearchPage = location.pathname === '/search';
    const isNavigatingAway = path !== '/search';
    const shouldPreserveSearch = isOnSearchPage && hasSearch && isNavigatingAway;
    
    const isReturningToSearch = path === '/search' && 
                               (location.state?.from?.startsWith('/search') || 
                                location.state?.preservedSearch);
    
    if (process.env.NODE_ENV === 'development' && location.pathname !== path) {
      console.debug('NavLink path change:', {
        from: location.pathname,
        to: path,
        hasSearch,
        preservedSearch: location.state?.preservedSearch
      });
    }

    if (shouldPreserveSearch) {
      const to = { 
        pathname: path, 
        state: { 
          from: location.pathname + location.search,
          preservedSearch: location.search || location.state?.activeSearch,
          activeSearch: location.state?.activeSearch,
          timestamp: Date.now()
        }
      };
      console.log('Preserving search state:', {
        to,
        originalSearch: location.search,
        originalState: location.state
      });
      return to;
    }

    if (isReturningToSearch) {
      const to = {
        pathname: path,
        search: location.state?.preservedSearch || '',
        state: { 
          restored: true,
          preservedSearch: location.state?.preservedSearch,
          activeSearch: location.state?.activeSearch,
          timestamp: Date.now(),
          previousState: location.state
        }
      };
      console.log('Restoring search state:', {
        to,
        fromState: location.state,
        preservedSearch: location.state?.preservedSearch
      });
      return to;
    }
    
    return path;
  };

  return (
    <nav className="navbar">
      <div className="nav-links">
        <NavLink 
          to={getNavLinkTo('/popular')} 
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
          <i className="fas fa-fire"></i>
          <span>Smultron</span>
        </NavLink>
        <NavLink 
          to={getNavLinkTo('/search')} 
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
          state={location.state?.preservedSearch ? {
            restored: true,
            preservedSearch: location.state.preservedSearch
          } : undefined}
        >
          <i className="fas fa-search"></i>
          <span>Lägg till</span>
        </NavLink>
        <NavLink 
          to={getNavLinkTo('/activity')} 
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
          <i className="fas fa-bell"></i>
          <span>Aktivitet</span>
        </NavLink>
        <NavLink 
          to={getNavLinkTo('/tips')} 
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
          <i className="fas fa-lightbulb"></i>
          <span>Tips</span>
        </NavLink>
        <NavLink 
          to={getNavLinkTo('/friends')} 
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
          <i className="fas fa-users"></i>
          <span>Användare</span>
        </NavLink>
      </div>
    </nav>
  );
}

export default Navbar; 